import React from 'react'
import { DefaultTableCol, DescriptionName, TeamsTableCol } from './weekStyles'
import type { EventGQL } from '../../../../Api'
import { TeamItem } from './TeamItem'
import { TeamScore } from './TeamScore'
import { SEASON_SEGMENT_NAMES } from '../../../../Utils'
type TeamsColParams = {
  description: string
  event: EventGQL
}

export const TeamsCol: React.FC<React.PropsWithChildren<TeamsColParams>> = ({
  event,
  description,
}) => {

  const showDescription = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.allstar) {
      if (event.slugname.includes('skill')) return true
      if (!event.awayTeam || !event.homeTeam) return true
    }

    if (
      event.seasonSegment === SEASON_SEGMENT_NAMES.post &&
      !event?.awayTeam &&
      !event?.homeTeam
    )
      return true

    return false
  }

  if (showDescription()) {
    return (
      <DefaultTableCol>
        <DescriptionName justify="center">{description}</DescriptionName>
      </DefaultTableCol>
    )
  }

  return (
    <TeamsTableCol>
      <div className="innerCol">
        {event.eventStatus === 1 && <div className="live">Live</div>}
        <div className="results">
          <TeamItem event={event} description={description} teamStatus={'away'} />
          {event.eventStatus > 0 && <TeamScore score={event.visitorScore} />}
          <div className="vs">vs</div>
          {event.eventStatus > 0 && <TeamScore score={event.homeScore} />}
          <TeamItem event={event} description={description} teamStatus={'home'} />
        </div>
      </div>
    </TeamsTableCol>
  )
}
